import { ReactNodeViewRenderer } from '@tiptap/react';
import { EmbedContentView } from './EmbedContent.renderer';
import { EmbedContentExt } from '@distribute/shared/tiptap/extensions';

export const EmbedContent = EmbedContentExt.extend({
  addNodeView() {
    return ReactNodeViewRenderer(EmbedContentView);
  },
});
